import { Pipe, PipeTransform } from "@angular/core";

import { Size } from "../../model/media.types";

interface PosterUrlOptions {
    mobileUrl?: string;
    size: Size;
    width: number;
    height?: number;
    fit?: string;
}

@Pipe({
    name: "hPosterUrl",
})
export class PosterUrlPipe implements PipeTransform {
    public transform(
        url: string,
        { mobileUrl, size, width, height, fit }: PosterUrlOptions,
    ): string {
        return toPosterUrlOptions(url, { mobileUrl, size, width, height, fit });
    }
}

export function toPosterUrlOptions(
    url: string,
    { mobileUrl, size, width, height, fit = "wrap,0" }: PosterUrlOptions,
): string {
    const posterUrl = getUrlForSize({ mobileUrl, size, url });
    let urlWithSize = `${posterUrl}${posterUrl.includes("?") ? "&" : "?"}fit=${encodeURIComponent(fit)}&wid=${width}`;

    if (height) {
        urlWithSize += `&hei=${height}`;
    }

    return `${urlWithSize}&resMode=sharp2&op_usm=1%2C1%2C6%2C0`;
}

export const getUrlForSize = ({
    mobileUrl,
    size,
    url,
}: {
    mobileUrl?: string;
    size: Size;
    url: string;
}) => (isMobileSize({ size }) ? mobileUrl || url : url);

const isMobileSize = ({ size }: { size: Size }) =>
    ["xsmall", "small", "medium"].includes(size);
